import { render } from "./BarProgress.vue?vue&type=template&id=58316d60"
import script from "./BarProgress.vue?vue&type=script&lang=js"
export * from "./BarProgress.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/BarProgress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58316d60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58316d60', __exports__)) {
    api.reload('58316d60', __exports__)
  }
  
  module.hot.accept("./BarProgress.vue?vue&type=template&id=58316d60", () => {
    api.rerender('58316d60', render)
  })

}


export default __exports__